import { render } from "./MensagemComposer.vue?vue&type=template&id=6aa01c97&scoped=true"
import script from "./MensagemComposer.vue?vue&type=script&lang=js"
export * from "./MensagemComposer.vue?vue&type=script&lang=js"

import "./MensagemComposer.vue?vue&type=style&index=0&id=6aa01c97&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa01c97"]])

export default __exports__